import { Field, ErrorMessage } from "formik";
import { useState } from "react";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import deleteIcon from "../../assets/icons/delete-bin.svg";

const FormTextArrayField = ({
  name = "textArrayField",
  label = "textArrayField",
  labelClassName = "",
  placeholder = "Enter value",
  className = "",
  itemClassName = "",
}) => {
  const [newValue, setNewValue] = useState("");

  return (
    <div className="w-full">
      <Field name={name}>
        {({ form, meta }) => {
          const values = form.values;
          const setFieldValue = form.setFieldValue;
          const items = values[name] || [];

          const handleAdd = () => {
            if (newValue && !items.includes(newValue)) {
              setFieldValue(name, [...items, newValue]);
              setNewValue("");
            }
          };

          const handleRemove = (index) => {
            const updated = items.filter((_, i) => i !== index);
            setFieldValue(name, updated);
          };

          return (
            <>
              <div className="mb-5">
                <label
                  htmlFor={`input-${name}`}
                  className={`text-fs_14 md:text-fs_16 font-fw_400 ${
                    meta.touched && meta.error ? "text-errorColor" : ""
                  } ${labelClassName}`}
                >
                  {formatUnderscoreToSpace(name)}
                </label>
                <div className="mt-2 flex items-center gap-4">
                  <input
                    id={`input-${name}`}
                    type="text"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                          meta.touched && meta.error
                            ? "border-errorColor"
                            : "border-greyText"
                        }`}
                    placeholder={placeholder}
                  />
                  {items.includes(newValue) ? (
                    <p className="text-errorColor text-fs_12">Already Exists</p>
                  ) : (
                    newValue && (
                      <button
                        type="button"
                        className="text-secondary text-nowrap text-fs_14"
                        onClick={handleAdd}
                      >
                        Add
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="pt-2 flex flex-wrap gap-3 relative">
                {items.map((item, index) => (
                  <div
                    key={index}
                    className={`flex items-center gap-4 relative bg-white mx-2 ${itemClassName}`}
                  >
                    <label className="border-[1.5px] border-lightGrey px-4 py-1 rounded-lg">
                      {item}
                    </label>
                    <button
                      type="button"
                      onClick={() => handleRemove(index)}
                      className="text-red-500 text-xs cursor-pointer p-1 rounded-full shadow-sm absolute top-[-0.5rem] right-[-0.8rem] opacity-60 bg-errorColor"
                    >
                      <img src={deleteIcon} width={14} height={14} />
                    </button>
                  </div>
                ))}
              </div>
              <label className="text-errorColor text-fs_14 ps-1 h-[1rem] block mt-2">
                <ErrorMessage name={name} />
              </label>
            </>
          );
        }}
      </Field>
    </div>
  );
};

export default FormTextArrayField;
